/*
 * Small, defensive accessibility enhancements that run on every page.
 *
 * Carousel arrow labels: some sliders (Flickity / theme sliders on the
 * "You may also like" and "Recently viewed" rows) generate prev/next <button>s
 * with no accessible name. This labels any unlabeled arrow as Previous/Next.
 * It is library-agnostic and re-runs for lazily-loaded carousels.
 */
(function () {
  'use strict';

  function hasAccessibleName(el) {
    var al = el.getAttribute('aria-label');
    if (al && al.trim()) return true;
    if (el.getAttribute('aria-labelledby')) return true;
    if ((el.textContent || '').trim()) return true;
    var title = el.getAttribute('title');
    if (title && title.trim()) return true;
    var img = el.querySelector('img[alt]');
    if (img && (img.getAttribute('alt') || '').trim()) return true;
    var svgTitle = el.querySelector('svg title');
    if (svgTitle && (svgTitle.textContent || '').trim()) return true;
    return false;
  }

  var ARROW_SELECTOR = [
    '.flickity-prev-next-button',
    '.slick-prev',
    '.slick-next',
    '[class*="slider-control"]',
    '[class*="slider__arrow"]',
    '[class*="carousel"] button[class*="arrow"]',
    'button[class*="arrow"]',
    '[data-slider-wrapper] button'
  ].join(',');

  function labelArrows() {
    var nodes = document.querySelectorAll(ARROW_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var b = nodes[i];
      if (b.tagName !== 'BUTTON' && b.getAttribute('role') !== 'button') continue;
      if (hasAccessibleName(b)) continue;
      // Direction detection. Note: some libraries use a combined base class
      // ("flickity-prev-next-button") containing BOTH words, so we must look at the
      // distinguishing class token, not a naive substring.
      var classes = (b.className || '').toString().toLowerCase().split(/\s+/);
      var label = '';
      if (classes.indexOf('next') !== -1 || classes.indexOf('right') !== -1) {
        label = 'Next';
      } else if (classes.indexOf('previous') !== -1 || classes.indexOf('prev') !== -1 || classes.indexOf('left') !== -1) {
        label = 'Previous';
      } else {
        // modifier-style (slick-next, splide__arrow--next, pswp__button--arrow--right, --prev/--left),
        // ignoring the "prev-next" combo token
        var c = (b.className || '').toString().toLowerCase().replace(/prev-next/g, ' ');
        if (/(?:--|__|-)(next|right)\b|button-next|next-button/.test(c)) label = 'Next';
        else if (/(?:--|__|-)(prev(?:ious)?|left)\b|button-prev|prev-button/.test(c)) label = 'Previous';
      }
      if (label) b.setAttribute('aria-label', label); // else leave it rather than mislabel
    }
  }

  var scheduled = false;
  function scheduleLabel() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () { scheduled = false; labelArrows(); }, 200);
  }

  function init() {
    labelArrows();
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scheduleLabel(); break; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/*
 * Collection filter/sort focus restoration + result announcement.
 * Two paths:
 *  - Full reload (price filter): flag the navigation in sessionStorage, then on load move
 *    focus to the results and announce the count.
 *  - AJAX swap (facet links / sort): Empire replaces the grid contents WITHOUT a reload, so
 *    watch the grid for swaps after a filter interaction and announce + restore focus there.
 */
(function () {
  'use strict';
  var REFINE_KEY = 'a11y_collection_refine';
  if (!document.querySelector('[data-productgrid-items], .productgrid--no-results')) return; // not a collection page

  function grid() { return document.querySelector('[data-productgrid-items]'); }
  function countProducts(g) {
    if (!g) return 0;
    var items = g.querySelectorAll('[data-product-item]');
    return items.length || g.querySelectorAll('li').length;
  }

  var region = document.createElement('div');
  region.setAttribute('role', 'status');
  region.setAttribute('aria-live', 'polite');
  region.setAttribute('aria-atomic', 'true');
  region.className = 'visually-hidden';
  document.body.appendChild(region);

  function announceAndFocus(onlyIfFocusLost) {
    var g = grid();
    var noResults = document.querySelector('.productgrid--no-results');
    var msg = (g && countProducts(g) > 0)
      ? 'Showing ' + countProducts(g) + ' products'
      : 'No products match your filters';
    var target = g || noResults;
    // After an AJAX swap the user may still be on the filter they clicked — don't yank
    // focus away from them; only repair it when the re-render actually destroyed it.
    var focusLost = document.activeElement === document.body || document.activeElement === null ||
      !document.contains(document.activeElement);
    if (target && (!onlyIfFocusLost || focusLost)) {
      target.setAttribute('tabindex', '-1');
      if (!target.getAttribute('aria-label')) target.setAttribute('aria-label', 'Product results');
      target.focus();
    }
    window.setTimeout(function () { region.textContent = msg; }, 150);
  }

  function markRefine() { try { sessionStorage.setItem(REFINE_KEY, '1'); } catch (e) {} }

  // Flag filter/sort interactions (used by BOTH the reload and the AJAX path).
  var pendingAjax = 0;
  function markInteraction() {
    markRefine(); // harmless if no reload happens
    pendingAjax = Date.now();
  }
  var sortSelect = document.querySelector('#product_grid_sort, select[name="sort_by"]');
  if (sortSelect) sortSelect.addEventListener('change', markInteraction);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('a[href*="filter."]:not([aria-disabled="true"]), a[href*="sort_by="], [data-filter-active], [data-filter-input]:not([data-disabled]), [data-productgrid-trigger-sort-button], [data-price-range-apply]')) markInteraction();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-filter-group], [data-productgrid-sort], select[name="sort_by"]')) markInteraction();
  }, true);

  // AJAX path: after a filter interaction, the grid's children get replaced in place.
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function (muts) {
      // Only react shortly after a filter/sort interaction — not on unrelated DOM churn.
      if (!pendingAjax || Date.now() - pendingAjax > 15000) return;
      var relevant = false;
      for (var i = 0; i < muts.length; i++) {
        var tgt = muts[i].target;
        if (tgt && tgt.nodeType === 1 && tgt.closest &&
            tgt.closest('[data-productgrid-items], [data-productgrid], .productgrid--outer, [data-section-type="collection"]')) {
          relevant = true; break;
        }
      }
      if (!relevant) return;
      window.clearTimeout(t);
      t = window.setTimeout(function () {
        pendingAjax = 0;
        try { sessionStorage.removeItem(REFINE_KEY); } catch (e) {}
        announceAndFocus(true);
      }, 350);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Reload path: if the last navigation came from a filter/sort action, restore focus now.
  var refined = false;
  try { refined = sessionStorage.getItem(REFINE_KEY) === '1'; if (refined) sessionStorage.removeItem(REFINE_KEY); } catch (e) {}
  if (refined) requestAnimationFrame(function () { announceAndFocus(false); });
})();

/*
 * Collection price-range filter (WCAG 3.2.2 / htmlcs H32).
 * The theme silently reloads the page 2 seconds after the last keystroke in the price
 * fields — an unannounced context change. The form now has a real Apply submit button
 * (faceted-filter-group.liquid); here we (a) stop the theme's silent auto-reload by
 * blocking its keyup/change handlers on the price inputs, and (b) apply the filter on
 * submit (Apply click or Enter), preserving all other active filter params.
 */
(function () {
  'use strict';
  function isPriceInput(el) {
    return el && el.matches && el.matches('.collection-filters__price-range-form [data-filter-range]');
  }
  // Capture at document level so the theme's input-level keyup/change handlers never fire.
  ['keyup', 'change'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (isPriceInput(e.target)) e.stopPropagation();
    }, true);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.collection-filters__price-range-form');
    if (!form) return;
    e.preventDefault();
    var params = new URLSearchParams(window.location.search);
    params.delete('page'); // a changed filter restarts pagination
    var inputs = form.querySelectorAll('[data-filter-range]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (!inp.name) continue;
      params.delete(inp.name);
      if (inp.value !== '') params.set(inp.name, inp.value);
    }
    var qs = params.toString();
    window.location.search = qs ? '?' + qs : '';
  }, true);
})();

/*
 * Predictive-search combobox (ARIA 1.2) — deep audit #21/#22 + announcer rework.
 * The template (sections/predictive-search.liquid) ships role=listbox/group/option markup;
 * this controller wires each live-search instance's input to its rendered listbox:
 *   - aria-controls / aria-expanded synced to the flydown's actual visibility
 *   - ArrowUp/Down/Home/End move a virtual cursor (aria-activedescendant), Enter activates
 *   - result counts announced per instance (all suggestion types, not just products)
 */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-live-search]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root, idx) {
    var input = root.querySelector('[data-live-search-input]');
    var flydown = root.querySelector('[data-live-search-flydown]');
    if (!input || !flydown) return;
    var uid = 'a11y-ls' + idx;
    var active = -1;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    if (!input.getAttribute('aria-expanded')) input.setAttribute('aria-expanded', 'false');

    var region = document.createElement('div');
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    region.className = 'visually-hidden';
    region.setAttribute('data-search-status', '');
    root.appendChild(region);

    function listbox() { return flydown.querySelector('[data-predictive-results]'); }
    function isOpen() { return flydown.getBoundingClientRect().height > 20; }
    function options() {
      var lb = listbox();
      if (!lb) return [];
      return Array.prototype.filter.call(lb.querySelectorAll('a[role="option"]'), function (a) {
        var href = a.getAttribute('href');
        // exclude hidden/collapsed options — stale ids on aria-activedescendant otherwise
        return href && href !== '#' && a.getAttribute('aria-hidden') !== 'true' && a.getClientRects().length > 0;
      });
    }

    function setActive(i) {
      var opts = options();
      Array.prototype.forEach.call(opts, function (o) {
        o.removeAttribute('data-a11y-active');
        o.setAttribute('aria-selected', 'false');
      });
      active = i;
      if (i >= 0 && opts[i]) {
        opts[i].setAttribute('data-a11y-active', '');
        opts[i].setAttribute('aria-selected', 'true');
        input.setAttribute('aria-activedescendant', opts[i].id);
        if (opts[i].scrollIntoView) opts[i].scrollIntoView({ block: 'nearest' });
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    var lastMsg = '';
    function sync() {
      var lb = listbox();
      // Only a real listbox counts as the expanded popup — the no-results state renders
      // the container without role=listbox (it holds a <p>, not options).
      var isListbox = !!lb && lb.getAttribute('role') === 'listbox';
      if (isListbox) {
        if (!lb.id) lb.id = uid + '-listbox';
        input.setAttribute('aria-controls', lb.id);
      } else {
        input.removeAttribute('aria-controls');
      }
      var open = isOpen() && isListbox;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      var opts = options();
      for (var i = 0; i < opts.length; i++) if (!opts[i].id) opts[i].id = uid + '-opt-' + i;
      if (active >= opts.length) setActive(-1);

      // Announce result count (all suggestion types; the no-results <p> means zero).
      if (!open) { lastMsg = ''; return; }
      var q = (input.value || '').trim();
      if (!q) return;
      var noResults = lb.querySelector('.search-flydown__no-results');
      var msg = (opts.length > 0)
        ? opts.length + (opts.length === 1 ? ' suggestion' : ' suggestions') + ' for “' + q + '”'
        : (noResults ? 'No results for “' + q + '”' : '');
      if (!msg || msg === lastMsg) return;
      lastMsg = msg;
      region.textContent = '';
      window.setTimeout(function () { region.textContent = msg; }, 50);
    }

    input.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      var opts = options();
      if (!opts.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active < opts.length - 1 ? active + 1 : 0); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active > 0 ? active - 1 : opts.length - 1); }
      else if (e.key === 'Home' && active >= 0) { e.preventDefault(); setActive(0); }
      else if (e.key === 'End' && active >= 0) { e.preventDefault(); setActive(opts.length - 1); }
      else if (e.key === 'Enter' && active >= 0 && opts[active]) {
        e.preventDefault();
        var href = opts[active].getAttribute('href');
        opts[active].click();
        if (href && href !== '#') window.location.href = href;
      } else if (e.key === 'Escape') { setActive(-1); } // theme closes the flydown
    });
    input.addEventListener('input', function () { setActive(-1); });

    if (window.MutationObserver) {
      var t;
      new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(sync, 150); })
        .observe(flydown, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'data-animation', 'data-animation-state'] });
    }
    sync();

    // Closing the flydown (Escape, document-click dismiss) or the mobile takeover (Cancel)
    // must not drop keyboard focus onto a hidden element / <body> (WCAG 2.4.3).
    // RESTORE TARGET IS THE SUBMIT BUTTON, NOT THE INPUT: the theme re-opens the flydown
    // whenever the input gains focus, so input.focus() resurrected the popup the user had
    // just dismissed (an open/close loop). The adjacent named Search button is loop-safe.
    // The watcher only polls WHILE search is in use (armed on focus/typing).
    function restoreTarget() {
      return root.querySelector('[data-live-search-submit]') || input;
    }
    var closeWatch = null;
    function armCloseWatch() {
      if (closeWatch) return;
      var wasOpen = false;
      closeWatch = window.setInterval(function () {
        var open = isOpen();
        if (wasOpen && !open) {
          var ae = document.activeElement;
          var lost = !ae || ae === document.body || flydown.contains(ae) ||
            (ae.offsetParent === null && !ae.getClientRects().length);
          if (lost) { try { restoreTarget().focus(); } catch (e) {} }
          setActive(-1);
          input.removeAttribute('aria-activedescendant');
          input.setAttribute('aria-expanded', 'false'); // settle the state even if the MO debounce lost the race
          window.clearInterval(closeWatch);
          closeWatch = null;
          return;
        }
        if (!open && !(document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-live-search]'))) {
          window.clearInterval(closeWatch); // never opened — disarm
          closeWatch = null;
          return;
        }
        wasOpen = open;
      }, 250);
    }
    input.addEventListener('focus', armCloseWatch);
    input.addEventListener('input', armCloseWatch);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-live-search-takeover-cancel]')) {
        window.setTimeout(function () {
          if (document.activeElement === document.body || (document.activeElement && document.activeElement.offsetParent === null)) {
            // submit button, NOT the input — input.focus() re-opens the takeover just closed
            try { restoreTarget().focus(); } catch (err) {}
          }
        }, 120);
      }
    });
  });
})();

/*
 * PhotoSwipe lightbox (the product image "click to expand" / zoom) accessibility.
 * The bundled PhotoSwipe generates its close/arrow/zoom buttons with NO accessible names,
 * the zoomed <img> has NO alt, and the dialog lacks aria-modal. Patch all of that whenever
 * a lightbox is present (it is created dynamically on open).
 */
(function () {
  'use strict';
  var BTN = [
    ['.pswp__button--close', 'Close'],
    ['.pswp__button--arrow--left', 'Previous image'],
    ['.pswp__button--arrow--right', 'Next image'],
    ['.pswp__button--prev', 'Previous image'],
    ['.pswp__button--next', 'Next image'],
    ['.pswp__button--zoom', 'Zoom'],
    ['.pswp__button--fs', 'Toggle fullscreen'],
    ['.pswp__button--share', 'Share']
  ];

  function patch() {
    var pswp = document.querySelector('.pswp');
    if (!pswp) return;
    if (pswp.getAttribute('role') === 'dialog' && !pswp.getAttribute('aria-modal')) {
      pswp.setAttribute('aria-modal', 'true');
    }
    for (var i = 0; i < BTN.length; i++) {
      var nodes = pswp.querySelectorAll(BTN[i][0]);
      for (var j = 0; j < nodes.length; j++) {
        var b = nodes[j];
        // Only name genuinely-unnamed buttons — don't clobber an existing aria-label/title/text
        // (PhotoSwipe may set title="Zoom in/out" etc., which is more specific than our generic label).
        var has = (b.getAttribute('aria-label') || '').trim() || (b.getAttribute('title') || '').trim() || (b.textContent || '').trim();
        if (!has) b.setAttribute('aria-label', BTN[i][1]);
      }
    }
    // NOTE: zoomed-image alt is owned by empire.js syncZoomAlt (per-slide, correct image,
    // skips the placeholder). The old fallback here stamped gallery image #1's alt onto
    // EVERY slide — wrong text is worse than none, so it was removed.
  }

  var t;
  if (window.MutationObserver) {
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 150); })
      .observe(document.body, { childList: true, subtree: true });
  }
  // PhotoSwipe opens on click; re-run shortly after.
  document.addEventListener('click', function () { window.setTimeout(patch, 350); }, true);
})();

/* Slideshow: expose carousel role + reflect the active dot to SR (theme uses data-selected only). */
(function () {
  'use strict';
  function patch() {
    var ss = document.querySelector('[data-slideshow]');
    if (ss && !ss.getAttribute('aria-roledescription')) {
      if (!ss.getAttribute('role')) ss.setAttribute('role', 'region');
      ss.setAttribute('aria-roledescription', 'carousel');
    }
    var btns = document.querySelectorAll('.slideshow-pagination__button');
    for (var i = 0; i < btns.length; i++) {
      var sel = btns[i].getAttribute('data-selected') === 'true' || btns[i].getAttribute('aria-selected') === 'true';
      if (sel) btns[i].setAttribute('aria-current', 'true');
      else btns[i].removeAttribute('aria-current');
      // aria-selected is invalid on plain buttons (axe aria-allowed-attr) — strip any
      // stale stamping (empire.js _updatePagination now uses aria-current, this self-heals).
      btns[i].removeAttribute('aria-selected');
    }
  }
  var t;
  if (window.MutationObserver) {
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 150); })
      .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-selected', 'aria-selected', 'class'] });
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
})();

/* Title any untitled <iframe> (Shopify web-pixels analytics frames, etc.) — clears frame-title flags. */
(function () {
  'use strict';
  function patch() {
    var frames = document.querySelectorAll('iframe:not([title]), iframe[title=""]');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      var src = (f.getAttribute('src') || '') + (f.id || '') + (f.className || '');
      var t = /web-pixel|pixel|analytics|gtm|google/i.test(src) ? 'Analytics'
            : /recaptcha|captcha/i.test(src) ? 'Security check'
            : 'Embedded content';
      f.setAttribute('title', t);
    }
  }
  var t;
  if (window.MutationObserver) {
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 200); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
})();

/* Account + contact forms: move focus to the error alert ONCE on load (so SR users hear it)
   + label hidden captcha fields. The focus move must not repeat — re-running on every DOM
   mutation kept yanking focus back to the alert for the life of the page. */
(function () {
  'use strict';
  function patch() {
    var alert = document.querySelector('[data-account-message][role="alert"], [data-account-message][role="status"], .newsletter-success[role="status"]');
    if (alert && !alert.hasAttribute('data-a11y-focused') && document.activeElement === document.body) {
      alert.setAttribute('data-a11y-focused', '');
      if (!alert.hasAttribute('tabindex')) alert.setAttribute('tabindex', '-1');
      try { alert.focus(); } catch (e) {}
    }
    var caps = document.querySelectorAll('textarea[name*="captcha"]:not([aria-label]), input[name*="captcha"]:not([aria-label])');
    for (var i = 0; i < caps.length; i++) caps[i].setAttribute('aria-label', 'Captcha verification response');
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 300); }).observe(document.body, { childList: true, subtree: true }); }
})();

/* Name image-only links that can end up unnamed: site logo (account layout) + cart-drawer item image (when item.image is blank). Defensive: only acts on genuinely-unnamed elements. */
(function () {
  'use strict';
  function named(el) {
    var al = el.getAttribute('aria-label'); if (al && al.trim()) return true;
    if ((el.textContent || '').trim()) return true;
    var i = el.querySelector('img[alt]'); if (i && (i.getAttribute('alt') || '').trim()) return true;
    return false;
  }
  function patch() {
    var logos = document.querySelectorAll('a.site-logo');
    for (var i = 0; i < logos.length; i++) if (!named(logos[i])) logos[i].setAttribute('aria-label', 'Don’s Liquors & Wine — home');
    var imgs = document.querySelectorAll('a.cart-drawer__item-image');
    for (var j = 0; j < imgs.length; j++) {
      if (!named(imgs[j])) {
        var item = imgs[j].closest('[data-cart-drawer-item]');
        var t = item && item.querySelector('.cart-drawer__item-title');
        imgs[j].setAttribute('aria-label', (t && t.textContent.trim()) || 'Product');
      }
    }
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
  if (window.MutationObserver) { var to; new MutationObserver(function () { window.clearTimeout(to); to = window.setTimeout(patch, 300); }).observe(document.body, { childList: true, subtree: true }); }
})();

/* Third-party widget naming: hidden <variant-selection> <select> + buy-me social-share icon links. */
(function () {
  'use strict';
  var SHARE = [['fac-link', 'Share on Facebook'], ['twi-link', 'Share on X'], ['lki-link', 'Share on LinkedIn'],
    ['pin-link', 'Share on Pinterest'], ['eml-link', 'Share by email'], ['cop-link', 'Copy link'], ['wha-link', 'Share on WhatsApp']];
  function named(el) { return (el.getAttribute('aria-label') || '').trim() || (el.textContent || '').trim() || (el.labels && el.labels.length); }
  function patch() {
    var vs = document.querySelectorAll('variant-selection select');
    // NB: a <select>'s textContent is its option labels, which is NOT an accessible name —
    // only count aria-label / an associated <label>.
    for (var i = 0; i < vs.length; i++) if (!(vs[i].getAttribute('aria-label') || '').trim() && !(vs[i].labels && vs[i].labels.length)) vs[i].setAttribute('aria-label', 'Variant');
    for (var j = 0; j < SHARE.length; j++) {
      var els = document.querySelectorAll('#buy-me a.' + SHARE[j][0]);
      for (var k = 0; k < els.length; k++) if (!named(els[k])) els[k].setAttribute('aria-label', SHARE[j][1]);
    }
    var bm = document.querySelectorAll('#buy-me a:not([aria-label])');
    for (var m = 0; m < bm.length; m++) if (!(bm[m].textContent || '').trim() && bm[m].getAttribute('title')) bm[m].setAttribute('aria-label', bm[m].getAttribute('title'));
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 300); }).observe(document.body, { childList: true, subtree: true }); }
})();

/* Mobile nav: expose open/closed state via aria-expanded.
   FIX (deep audit): the hamburger's open state lives on #site-mobile-nav[data-open="true"],
   NOT on the toggle's own class — so mirror THAT. Also link them with aria-controls. */
(function () {
  'use strict';
  var ham = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('#site-mobile-nav, [data-mobile-nav]');
  if (!ham) return;
  if (nav && nav.id && !ham.getAttribute('aria-controls')) ham.setAttribute('aria-controls', nav.id);
  function syncHam() {
    var open = nav ? nav.getAttribute('data-open') === 'true' : ham.classList.contains('active');
    ham.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  syncHam();
  if (window.MutationObserver) {
    if (nav) new MutationObserver(syncHam).observe(nav, { attributes: true, attributeFilter: ['data-open', 'class'] });
    new MutationObserver(syncHam).observe(ham, { attributes: true, attributeFilter: ['class'] });
  }
  ham.addEventListener('click', function () { window.setTimeout(syncHam, 50); });
})();

/* Footer menu accordion: now a real <button data-accordion-trigger aria-controls="...">.
   Reflect open/closed by watching the controlled panel's rendered height (theme toggles it on mobile). */
(function () {
  'use strict';
  var toggles = document.querySelectorAll('button[data-accordion-trigger][aria-controls]');
  for (var i = 0; i < toggles.length; i++) (function (btn) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    // Prefer the theme's own state attribute (set synchronously) over measuring height
    // mid-animation, which reported stale open/closed states.
    function sync() {
      if (!panel) return;
      var content = panel.querySelector('[data-accordion-content]') || panel;
      var state = content.getAttribute('data-accordion-state');
      var open = state ? state !== 'closed' : panel.offsetHeight > 0;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    sync();
    btn.addEventListener('click', function () { window.setTimeout(sync, 60); });
    if (window.MutationObserver && panel) new MutationObserver(sync).observe(panel, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'data-accordion-state', 'data-accordion-animation'] });
  })(toggles[i]);
})();

/* Footer newsletter: error/success render without focus or announcement — the account-form
   shim only matches [data-account-message]. Focus the newsletter error once on load. */
(function () {
  'use strict';
  function patch() {
    var el = document.querySelector('.newsletter-errors[role="alert"]:not([data-a11y-focused])');
    if (el && document.activeElement === document.body) {
      el.setAttribute('data-a11y-focused', '');
      el.setAttribute('tabindex', '-1');
      try { el.focus(); } catch (e) {}
    }
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
})();

/* Slideshow dots: roving tabindex — 25 dots were 25 consecutive tab stops (plus arrows),
   28 tabs to get past the hero. One tab stop; Left/Right/Home/End move and select. */
(function () {
  'use strict';
  // Scoped per pagination list — two slideshows on one page must each rove independently.
  function group(el) { return el.closest('.slideshow-pagination, ol, ul') || document; }
  function dots(scope) { return Array.prototype.slice.call(scope.querySelectorAll('.slideshow-pagination__button')); }
  function current(list) {
    for (var i = 0; i < list.length; i++) if (list[i].getAttribute('data-selected') === 'true') return i;
    return 0;
  }
  function rove() {
    var seen = [];
    document.querySelectorAll('.slideshow-pagination__button').forEach(function (b) {
      var g = group(b);
      if (seen.indexOf(g) !== -1) return;
      seen.push(g);
      var list = dots(g);
      if (list.length < 2) return;
      var cur = current(list);
      for (var i = 0; i < list.length; i++) list[i].setAttribute('tabindex', i === cur ? '0' : '-1');
    });
  }
  document.addEventListener('keydown', function (e) {
    var dot = e.target.closest && e.target.closest('.slideshow-pagination__button');
    if (!dot) return;
    var list = dots(group(dot));
    var idx = list.indexOf(dot);
    var next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % list.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + list.length) % list.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = list.length - 1;
    if (next < 0) return;
    e.preventDefault();
    list[next].focus();
    list[next].click();
  });
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(rove, 150); })
      .observe(document.body, { attributes: true, subtree: true, attributeFilter: ['data-selected'] });
  }
  if (document.readyState !== 'loading') rove(); else document.addEventListener('DOMContentLoaded', rove);
})();

/* Account forgot-password / cancel toggle: theme reveals the recovery/login form but never moves
   focus into it (deep audit finding). After the toggle, focus the now-visible form's first field. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-login-toggle]');
    if (!t) return;
    window.setTimeout(function () {
      var recovery = document.querySelector('.account-recovery.visible, #customer_recovery.visible, [data-account-login-recovery].visible');
      var login = document.querySelector('.account-login.visible, #customer_login.visible, [data-login].visible');
      var target = (recovery && recovery.offsetParent !== null) ? recovery : login;
      if (!target) return;
      var field = target.querySelector('input:not([type=hidden]), button, a[href]');
      if (field && typeof field.focus === 'function') field.focus();
    }, 80);
  });
})();

/* Scrollable regions (wide tables in policy/RTE/article content) must be keyboard-focusable
   (WCAG 2.1.1). NEVER put role/tabindex on the <table> itself — role="region" on a TABLE
   destroys its table semantics for screen readers. When the table IS the scroll container
   (.rte table { display:block; overflow:auto }), wrap it in a focusable region div instead. */
(function () {
  'use strict';
  function makeRegion(el) {
    el.setAttribute('tabindex', '0');
    if (!el.getAttribute('role')) el.setAttribute('role', 'region');
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', 'Scrollable content');
  }
  function patch() {
    var nodes = document.querySelectorAll('.rte table, .shopify-policy__body table, .article__content table, #site-main table, main table, .rte pre');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-a11y-scroll-done')) continue;
      var cs = window.getComputedStyle(el);
      var selfScrolls = /(auto|scroll)/.test(cs.overflowX + ' ' + cs.overflowY) &&
        (el.scrollWidth > el.clientWidth + 2 || el.scrollHeight > el.clientHeight + 2);
      var parent = el.parentElement;
      var pcs = parent ? window.getComputedStyle(parent) : null;
      var parentScrolls = pcs && /(auto|scroll)/.test(pcs.overflowX + ' ' + pcs.overflowY) &&
        (parent.scrollWidth > parent.clientWidth + 2 || parent.scrollHeight > parent.clientHeight + 2);
      if (!selfScrolls && !parentScrolls) continue;
      el.setAttribute('data-a11y-scroll-done', '');
      if (el.tagName === 'PRE') { if (selfScrolls && !el.hasAttribute('tabindex')) makeRegion(el); continue; }
      if (parentScrolls && parent.children.length === 1 && !parent.hasAttribute('tabindex')) { makeRegion(parent); continue; }
      if (selfScrolls) {
        // The table is its own scroll container — move the overflow onto a wrapper div.
        var wrap = document.createElement('div');
        wrap.style.overflowX = 'auto';
        makeRegion(wrap);
        el.parentNode.insertBefore(wrap, el);
        wrap.appendChild(el);
        el.style.overflow = 'visible';
      }
    }
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 400); }).observe(document.body, { childList: true, subtree: true }); }
})();

/*
 * Cart page: removing an item (or changing quantity) re-renders the list with morphdom,
 * destroying the control the keyboard user was on — focus silently drops to <body>
 * (WCAG 2.4.3) and nothing is announced (4.1.3). Track remove/qty interactions and,
 * after the list re-renders, restore focus to an equivalent control and announce.
 */
(function () {
  'use strict';
  var list = document.querySelector('[data-cart-item-list]');
  if (!list || !window.MutationObserver) return;

  var region = document.createElement('div');
  region.setAttribute('role', 'status');
  region.setAttribute('aria-live', 'polite');
  region.setAttribute('aria-atomic', 'true');
  region.className = 'visually-hidden';
  document.body.appendChild(region);
  function announce(msg) {
    region.textContent = '';
    window.setTimeout(function () { region.textContent = msg; }, 80);
  }

  var pending = null; // {type:'remove'|'qty', index, title}
  document.addEventListener('click', function (e) {
    var ctl = e.target.closest && e.target.closest('[data-cartitem-remove], [data-quantity-minus], [data-quantity-plus]');
    if (!ctl || !list.contains(ctl)) return;
    var item = ctl.closest('[data-cartitem]');
    var items = Array.prototype.slice.call(list.querySelectorAll('[data-cartitem]'));
    // First product link can be the IMAGE link (empty text) — find one with actual text.
    var title = 'item';
    if (item) {
      var links = item.querySelectorAll('.cart-item--content-title a, h2 a, a[href*="/products/"]');
      for (var li = 0; li < links.length; li++) {
        var t = links[li].textContent.replace(/\s+/g, ' ').trim();
        if (t) { title = t; break; }
      }
      if (title === 'item') {
        var rm = item.querySelector('[data-cartitem-remove]');
        var al = rm && rm.getAttribute('aria-label');
        if (al) title = al.replace(/^remove\s*/i, '').trim() || 'item';
      }
    }
    pending = {
      type: ctl.hasAttribute('data-cartitem-remove') ? 'remove' : 'qty',
      index: item ? items.indexOf(item) : -1,
      title: title
    };
  }, true);

  var t;
  new MutationObserver(function () {
    if (!pending) return;
    window.clearTimeout(t);
    t = window.setTimeout(function () {
      var p = pending; pending = null;
      var items = list.querySelectorAll('[data-cartitem]');
      var focusLost = document.activeElement === document.body || !document.contains(document.activeElement);
      if (p.type === 'remove') {
        announce(items.length === 0 ? p.title + ' removed. Your cart is empty' : p.title + ' removed from cart');
        if (focusLost) {
          var target = null;
          if (items.length > 0) {
            var idx = Math.min(p.index, items.length - 1);
            if (idx >= 0) target = items[idx].querySelector('[data-cartitem-remove]');
          }
          if (!target) target = document.querySelector('.cartitems--container h1, .cart-title, main h1, a[href="/collections/all"], main');
          if (target) {
            if (target.tabIndex < 0 && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
            try { target.focus(); } catch (e) {}
          }
        }
      } else if (focusLost && p.index >= 0 && items[p.index]) {
        var qty = items[p.index].querySelector('[data-quantity-input], input[type="number"]');
        if (qty) { try { qty.focus(); } catch (e) {} }
      }
    }, 250);
  }).observe(list, { childList: true, subtree: true });
})();

/*
 * Header cart count: the number is real text now (1.3.1), but the theme JS still updates
 * only the data attribute after AJAX cart changes — mirror it into the text + SR label.
 */
(function () {
  'use strict';
  var badge = document.querySelector('[data-header-cart-count]');
  if (!badge || !window.MutationObserver) return;
  var sr = document.querySelector('[data-header-cart-sr]');
  var srBase = sr ? (sr.textContent.split(',')[0] || 'Cart') : 'Cart';
  function sync() {
    var n = badge.getAttribute('data-header-cart-count') || '';
    if (badge.textContent !== n) badge.textContent = n;
    if (sr) sr.textContent = n ? srBase + ', ' + n + (n === '1' ? ' item' : ' items') : srBase;
  }
  new MutationObserver(sync).observe(badge, { attributes: true, attributeFilter: ['data-header-cart-count'] });
  sync();
})();

/*
 * Product description show-more (1.4.10/2.4.3): links clipped by the collapsed
 * max-height are still tabbable but invisible — expand the description as soon as
 * keyboard focus enters its clipped region.
 */
(function () {
  'use strict';
  document.addEventListener('focusin', function (e) {
    var content = e.target.closest && e.target.closest('.description-content');
    if (!content || content.classList.contains('expanded')) return;
    // Resolve THIS instance's toggle (ids are section-scoped now — quickshop + page coexist).
    var wrapper = content.closest('.product-description-collapsible');
    var toggle = wrapper && wrapper.querySelector('.toggle-description');
    if (toggle) toggle.click();
    else content.classList.add('expanded');
  });
})();

/*
 * Quantity steppers (cart page + product form): the minus button at qty<=min is only
 * VISUALLY disabled (wrapper class + pointer-events:none) — keyboard activation still fires
 * and at qty 1 silently DELETES the cart line. Guard activation at the minimum and expose
 * real disabled semantics to AT (WCAG 4.1.2).
 */
(function () {
  'use strict';
  function input(minus) {
    var root = minus.closest('[data-quantity-selector]') || minus.closest('form') || minus.parentElement.parentElement;
    return root ? root.querySelector('[data-quantity-input], input[type="number"]') : null;
  }
  function atMin(minus) {
    var inp = input(minus);
    if (!inp) return false;
    var min = parseInt(inp.getAttribute('min'), 10); if (isNaN(min)) min = 1;
    // The theme's REAL floor is the quantity increment (minus decrements by it and
    // visually disables at count <= increment) — keying off min alone reopened the
    // silent-deletion path for merchants with quantity_increment_value > 1.
    var inc = parseInt(inp.getAttribute('data-increment-value'), 10); if (isNaN(inc)) inc = 1;
    var floor = Math.max(min, inc);
    var val = parseInt(inp.value, 10); if (isNaN(val)) val = floor;
    return val <= floor;
  }
  // Block the deletion path: capture-phase so we beat the theme's handler.
  document.addEventListener('click', function (e) {
    var minus = e.target.closest && e.target.closest('[data-quantity-minus]');
    if (minus && atMin(minus)) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  // Typing '0' (or blanking) in a quantity input silently deletes the line after the theme's
  // 300ms debounce — clamp typed values to the input's min instead (WCAG 3.3.4-adjacent).
  document.addEventListener('keyup', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('[data-quantity-input], .quantity-selector input[type="number"], [data-cartitem] input[type="number"]')) return;
    if (inp.value === '') { e.stopPropagation(); return; } // mid-edit: hold the debounce, don't rewrite
    var min = parseInt(inp.getAttribute('min'), 10); if (isNaN(min)) min = 1;
    var val = parseInt(inp.value, 10);
    if (!isNaN(val) && val < min) {
      // Do NOT rewrite while the user is typing ("05" would become "15") — just keep the
      // theme's debounced commit from firing on the transient value; change/blur corrects it.
      e.stopPropagation();
    }
  }, true);
  // Commit-time correction: revert a below-min value to the last committed one + announce.
  ['change', 'blur'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches('[data-cartitem] input[type="number"], [data-quantity-input]')) return;
      if (inp.closest('[data-cart-drawer]')) return; // the drawer has its own revert handler
      var min = parseInt(inp.getAttribute('min'), 10); if (isNaN(min)) min = 1;
      var val = parseInt(inp.value, 10);
      if (isNaN(val) || val < min) {
        var prev = parseInt(inp.getAttribute('value'), 10);
        inp.value = isNaN(prev) || prev < min ? min : prev;
        if (type === 'change') e.stopPropagation(); // the corrected value is the committed one
        announceQty(inp, 'Quantity unchanged. Use Remove to delete this item.');
      }
    }, true);
  });
  // Announce the new quantity to SR users — the steppers give no feedback at all (4.1.3).
  var qRegion = null;
  function announceQty(inp, msg) {
    if (!qRegion) {
      qRegion = document.createElement('div');
      qRegion.setAttribute('role', 'status');
      qRegion.setAttribute('aria-live', 'polite');
      qRegion.setAttribute('aria-atomic', 'true');
      qRegion.className = 'visually-hidden';
      document.body.appendChild(qRegion);
    }
    var v = inp ? inp.value : '';
    qRegion.textContent = '';
    window.setTimeout(function () { qRegion.textContent = msg || ('Quantity ' + v); }, 80);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!btn) return;
    if (btn.hasAttribute('data-quantity-minus') && atMin(btn)) return; // blocked — no change
    // Cart rows already announce via their aria-live line total (and the drawer announces
    // its own updates) — a third generic message per click is over-announcement.
    if (btn.closest('[data-cartitem], [data-cart-drawer-item]')) return;
    window.setTimeout(function () { announceQty(input(btn)); }, 120);
  });
  // Mirror the state for AT.
  function sync() {
    var minuses = document.querySelectorAll('[data-quantity-minus]');
    for (var i = 0; i < minuses.length; i++) {
      if (atMin(minuses[i])) minuses[i].setAttribute('aria-disabled', 'true');
      else minuses[i].removeAttribute('aria-disabled');
    }
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-quantity-input], input[type="number"]')) sync(); }, true);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-quantity-minus], [data-quantity-plus]')) window.setTimeout(sync, 50); }, true);
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(sync, 300); }).observe(document.body, { childList: true, subtree: true }); }
})();

/*
 * Shared modal container ([data-modal-container] in layout/theme.liquid) hosts quickshop,
 * the mobile Filters modal, and the mobile Sort modal. The static label says "Quick view" —
 * rename it to match what is actually inside whenever content is injected (WCAG 4.1.2).
 */
(function () {
  'use strict';
  var modal = document.querySelector('[data-modal-container]');
  if (!modal || !window.MutationObserver) return;
  function relabel() {
    var content = modal.querySelector('[data-modal-content]');
    if (!content) return;
    var label = 'Quick view';
    var modalTitle = content.querySelector('.utils-sortby--modal-title');
    if (modalTitle && modalTitle.textContent.trim()) label = modalTitle.textContent.trim();
    else if (content.querySelector('[data-productgrid-trigger-sort-button], select[name="sort_by"]')) label = 'Sort by';
    else if (content.querySelector('[data-filter-group], .collection-filters')) label = 'Filters';
    if (modal.getAttribute('aria-label') !== label) modal.setAttribute('aria-label', label);
  }
  var t;
  new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(relabel, 100); })
    .observe(modal, { childList: true, subtree: true });
})();

/* Predictive search: loading-placeholder suggestion links (href="#"/empty) are bogus tab stops
   with a placeholder label — keep them out of the tab order + a11y tree (deep audit #23).
   Real result links (href="/products/...") are untouched. */
(function () {
  'use strict';
  var flydown = document.querySelector('.search-flydown');
  if (!flydown || !window.MutationObserver) return;
  function neutralize() {
    var links = flydown.querySelectorAll('a[href="#"], a[href=""], a:not([href])');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('tabindex', '-1');
      links[i].setAttribute('aria-hidden', 'true');
    }
  }
  neutralize();
  var t;
  new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(neutralize, 100); })
    .observe(flydown, { childList: true, subtree: true });
})();

/* Third-party free-shipping bar: the app renders the "$… Shipping on orders…" promo in
   MULTIPLE landmark regions (a complementary + duplicate banner copies), so a screen reader
   announces it 2–3× before any real content. Keep the first one; hide the rest from AT.
   (Visual is untouched — aria-hidden only affects assistive tech.) */
(function () {
  'use strict';
  // Match ONLY the promo BAR's own message ("$25 Shipping on orders over $199…").
  // NOT "Free Shipping" inside product titles (that wrongly hid product links).
  var BAR_RE = /shipping on orders over/i;
  function dedupe() {
    // STRUCTURE-PROOF: the 3P free-shipping bar lives in #fsb_container. Neutralize EVERY
    // landmark/group role inside it (and the container itself), no text gate — the bar's inner
    // markup/timing varies, so anchoring on the container is the only reliable way. The close
    // button + "$25 shipping" text + role=status stay (we only strip wrapper roles/names).
    var fsbBars = document.querySelectorAll('#fsb_container, [id^="fsb"], [class~="fsb"], [class^="fsb-"], [class*=" fsb-"]');
    for (var f = 0; f < fsbBars.length; f++) {
      var c = fsbBars[f];
      if (c.closest('[data-cart-drawer]')) continue; // not the in-cart free-shipping bar
      var cr = c.getAttribute('role');
      if (cr && ['group', 'region', 'complementary', 'banner'].indexOf(cr) !== -1) { c.setAttribute('role', 'presentation'); c.removeAttribute('aria-label'); }
      var inner = c.querySelectorAll('[role="group"], [role="region"], [role="complementary"], [role="banner"]');
      for (var q = 0; q < inner.length; q++) {
        if (inner[q].getAttribute('role') !== 'presentation') { inner[q].setAttribute('role', 'presentation'); inner[q].removeAttribute('aria-label'); }
      }
    }

    // The 3P free-shipping app wraps the "$25 shipping" bar in landmark(s) — a complementary
    // "Shipping promotion" (+ nested duplicate "Promotional banner" regions). These crowd the
    // Landmarks rotor (the bar shouldn't be a landmark). DEMOTE ALL of them to role=presentation
    // (removing the name) so NONE appear as landmarks — the message text + its role=status live
    // region stay intact (we demote, not aria-hidden, so the bar is still read/announced).
    var landmarks = [];
    var nodes = document.querySelectorAll('[role="region"], [role="complementary"], [role="banner"], [role="group"], section[aria-label], aside[aria-label], [aria-label*="promotional" i], [aria-label*="shipping promotion" i], [class*="free-shipping-bar"], [class*="fsb"], [data-free-shipping-bar]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.tagName === 'HEADER') continue;          // the real site banner
      if (el.closest('[data-cart-drawer]')) continue; // the in-drawer copy is its own context
      if (BAR_RE.test(el.textContent || '') && el.getClientRects().length) landmarks.push(el);
    }
    if (landmarks.length < 1) return;
    // demote EVERY promo landmark (the bar isn't a landmark) — message text stays readable
    for (var j = 0; j < landmarks.length; j++) {
      var d = landmarks[j];
      if (d.getAttribute('data-a11y-demoted')) continue;
      d.setAttribute('data-a11y-demoted', '');
      d.setAttribute('role', 'presentation');
      d.removeAttribute('aria-label');
    }
    // also collapse a nested duplicate text-exposer (role=text) so the message isn't read twice
    var texts = [];
    document.querySelectorAll('[role="text"]').forEach(function (t) { if (BAR_RE.test(t.textContent || '')) texts.push(t); });
    for (var k = 1; k < texts.length; k++) if (!texts[k].hasAttribute('aria-hidden')) texts[k].setAttribute('aria-hidden', 'true');
  }
  if (document.readyState !== 'loading') dedupe(); else document.addEventListener('DOMContentLoaded', dedupe);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(dedupe, 400); }).observe(document.body, { childList: true, subtree: true }); }
})();

/* Yotpo floating "Real Reviews" tab: a click-handler <div> with no role/name — a screen
   reader announces it as "Real Reviews, clickable". Make it a real, named button. */
(function () {
  'use strict';
  function patch() {
    var tabs = document.querySelectorAll('.yotpo-floating-tab, [class*="yotpo-floating-tab"]');
    for (var i = 0; i < tabs.length; i++) {
      var tab = tabs[i];
      // walk up to the outermost clickable wrapper of the floating tab
      var ctl = tab.closest('[class*="yotpo-floating-tab"]') || tab;
      if (ctl.getAttribute('data-a11y-named')) continue;
      ctl.setAttribute('data-a11y-named', '');
      if (!ctl.getAttribute('role') && ctl.tagName !== 'BUTTON' && ctl.tagName !== 'A') ctl.setAttribute('role', 'button');
      if (ctl.tabIndex < 0) ctl.setAttribute('tabindex', '0');
      if (!(ctl.getAttribute('aria-label') || '').trim()) ctl.setAttribute('aria-label', 'Open customer reviews');
    }
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 400); }).observe(document.body, { childList: true, subtree: true }); }
})();

/* Hero slideshow: all 25 slides sit in the DOM, so a screen reader reads EVERY slide's
   content, not just the visible one (huge noise). Hide all but the current slide from AT.
   "Current" = the slide whose index matches the selected pagination dot (the theme's own
   current-slide signal, same one we use for aria-current). Updates on every slide change. */
(function () {
  'use strict';
  function sync() {
    var groups = {};
    // group slides + their selected dot per slideshow container
    document.querySelectorAll('[data-slideshow]').forEach(function (ss, gi) {
      var slides = ss.querySelectorAll('[data-slideshow-slide]');
      if (slides.length < 2) return;
      var dot = ss.querySelector('.slideshow-pagination__button[data-selected="true"]');
      var cur = dot ? dot.getAttribute('data-slide-button') : (ss.querySelector('[data-slideshow-slide]') || {}).getAttribute && '0';
      if (cur == null) return; // can't determine — fail open (hide nothing)
      slides.forEach(function (s) {
        var isCur = s.getAttribute('data-slide-index') === String(cur);
        if (isCur) { s.removeAttribute('aria-hidden'); }
        else if (s.getAttribute('aria-hidden') !== 'true') { s.setAttribute('aria-hidden', 'true'); }
      });
    });
    return groups;
  }
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(sync, 120); })
      .observe(document.body, { attributes: true, subtree: true, attributeFilter: ['data-selected', 'class'] });
  }
})();

/* Phone / email links in body content (about text, FAQ, footer) often render as just the
   raw number/address ("408-225-2991") — out of reading flow a screen reader announces a bare
   number with no hint it's a callable phone. Give bare tel:/mailto: links a descriptive name. */
(function () {
  'use strict';
  function patch() {
    document.querySelectorAll('a[href^="tel:"]').forEach(function (a) {
      if (a.getAttribute('data-a11y-tel')) return;
      var txt = (a.textContent || '').replace(/\s+/g, ' ').trim();
      // only relabel when the visible text is essentially just the number (no words like "call")
      if (txt && !/[a-z]{3}/i.test(txt)) {
        a.setAttribute('data-a11y-tel', '');
        a.setAttribute('aria-label', 'Call us: ' + txt);
      }
    });
    document.querySelectorAll('a[href^="mailto:"]').forEach(function (a) {
      if (a.getAttribute('data-a11y-mail')) return;
      var txt = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt && /@/.test(txt) && !/[a-z]{3}\s[a-z]{3}/i.test(txt)) {
        a.setAttribute('data-a11y-mail', '');
        a.setAttribute('aria-label', 'Email us: ' + txt);
      }
    });
  }
  if (document.readyState !== 'loading') patch(); else document.addEventListener('DOMContentLoaded', patch);
  if (window.MutationObserver) { var t; new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(patch, 400); }).observe(document.body, { childList: true, subtree: true }); }
})();

/* Reading order: 3P widgets (free-shipping bar #fsb_container, Yotpo "Real Reviews" tab) inject
   themselves at the TOP of <body>, BEFORE the theme's "Skip to content" link — so a screen reader
   reads a promo + a reviews tab before reaching the skip link. Move the skip link to be the FIRST
   element in the body so it is always the first thing encountered (WCAG 2.4.1 Bypass Blocks). */
(function () {
  'use strict';
  function liftSkipLink() {
    var skip = document.querySelector('.skip-to-main, a[href="#site-main"]');
    if (!skip) return;
    var top = skip; // move the skip link (and its immediate wrapper if it is a thin wrapper)
    if (skip.parentElement && skip.parentElement.children.length === 1 && /skip/i.test(skip.parentElement.className || '')) top = skip.parentElement;
    if (document.body.firstElementChild !== top) document.body.insertBefore(top, document.body.firstElementChild);
  }
  if (document.readyState !== 'loading') liftSkipLink(); else document.addEventListener('DOMContentLoaded', liftSkipLink);
})();

/* "Learn more about Don's" disclosure: the collapsed content (#homepage-seo-expanded) is hidden
   only with max-height:0, so its 4 sub-headings still appear in the screen-reader Headings rotor
   and are readable while visually collapsed. Sync the content's AT-visibility with the button's
   aria-expanded using `inert` (keeps the max-height animation; removes it from the a11y tree +
   tab order while collapsed). */
(function () {
  'use strict';
  var wasExpanded = false;
  function sync() {
    var content = document.getElementById('homepage-seo-expanded');
    if (!content) return;
    var btn = document.querySelector('[aria-controls="homepage-seo-expanded"]');
    var expanded = btn ? btn.getAttribute('aria-expanded') === 'true' : false;
    if (expanded) {
      content.removeAttribute('inert');
      // The toggle sits AFTER the revealed content in the DOM, so on expand the user is left at
      // the BOTTOM. On the open transition, move focus to the TOP of the revealed content (its
      // first heading) so a keyboard/screen-reader user reads the new section from the start.
      if (!wasExpanded) {
        var top = content.querySelector('h1,h2,h3,h4,h5,h6') || content;
        top.setAttribute('tabindex', '-1');
        window.setTimeout(function () { try { top.focus({ preventScroll: false }); } catch (e) { top.focus(); } }, 80);
      }
    } else if (!content.hasAttribute('inert')) {
      content.setAttribute('inert', '');
    }
    wasExpanded = expanded;
  }
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(sync, 50); })
      .observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-expanded'] });
  }
})();

/* Reviews widget: each review renders its title as an <h3 class="review-title"> (e.g. "Elmer T.",
   "great product. well packaged…"), so review CONTENT pollutes the page's Headings outline and
   rotates as the carousel cycles. Demote review headings to role="presentation" — they stay
   visible/readable as text, but leave the heading outline. Keep the real "Real reviews…" section title. */
(function () {
  'use strict';
  function demoteReviewHeadings() {
    document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (h) {
      var cls = (h.className || '').toString();
      var txt = (h.textContent || '').replace(/\s+/g, ' ').trim();
      if (/review/i.test(cls) && !/real reviews from real customers/i.test(txt)) {
        if (h.getAttribute('role') !== 'presentation') h.setAttribute('role', 'presentation');
      }
    });
  }
  if (document.readyState !== 'loading') demoteReviewHeadings(); else document.addEventListener('DOMContentLoaded', demoteReviewHeadings);
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { window.clearTimeout(t); t = window.setTimeout(demoteReviewHeadings, 300); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();
